import { render, staticRenderFns } from "./PrecoDoDia.vue?vue&type=template&id=7bc52c6a&scoped=true&lang=pug"
import script from "./PrecoDoDia.vue?vue&type=script&lang=js"
export * from "./PrecoDoDia.vue?vue&type=script&lang=js"
import style0 from "./PrecoDoDia.styl?vue&type=style&index=0&id=7bc52c6a&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc52c6a",
  null
  
)

export default component.exports